import TeamVictoriesBarChart from './TeamVictoriesBarChart';

const TeamsPage = () => {
    return (
        <div>
            <TeamVictoriesBarChart />
        </div>
    );
};

export default TeamsPage;
